var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-12 col-lg buy-btn-col my-auto"},[_c('div',[_c('a',{staticClass:"btn revzilla-buy-btn",attrs:{"href":_vm.formattedRevzillaBuyURL,"target":"_blank"}},[_c('font-awesome-icon',{attrs:{"icon":"cart-plus"}}),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.formattedRevzillaBuyText))])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }